module.exports = __webpack_public_path__ + "static/media/configuration.7232945a.png";